export enum ResourceTypeEnum {
  'videoWelcome' = 'video-welcome',
  'videoThanks' = 'video-thanks',
  'videoQuestion' = 'video-question',
  'image' = 'image',
}
